import * as aa from "../generated/UserAPIAgent";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface MyDataState {
    user: aa.User | null;
    auth: {
        email: string | null;
    };
    shouldLoad: boolean;
    shouldRegister: boolean;
    isJustLoggedIn: boolean;
}

const initialState: MyDataState = {
    user: null,
    auth: {
        email: null
    },
    shouldLoad: true,
    shouldRegister: false,
    isJustLoggedIn: false
};

const myDataSlice = createSlice({
    name: "myData",
    initialState,
    reducers: {
        myDataUserSet: (state, action: PayloadAction<aa.User | null>) => {
            state.user = action.payload;
        },
        myDataAuthEmailSet: (state, action: PayloadAction<string | null>) => {
            state.auth.email = action.payload;
        },
        myDataShouldLoadSet: (state, action: PayloadAction<boolean>) => {
            state.shouldLoad = action.payload;
        },
        myDataShouldRegisterSet: (state, action: PayloadAction<boolean>) => {
            state.shouldRegister = action.payload;
        },
        myDataIsJustLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isJustLoggedIn = action.payload;
        }
    }
});

export const myDataActions = myDataSlice.actions;
export const myDataReducer = myDataSlice.reducer;
